module.exports = __webpack_public_path__ + "img/rva-m-321.37bfb15a.svg";